<app-demo-mode-banner></app-demo-mode-banner>
<app-service-notice-banner></app-service-notice-banner>

<div class="container-responsive-xl">
  <router-outlet inert></router-outlet>
</div>
